import { getAuthSession, getCurrentUserFromSession } from '@/composables/auth/oidc'
import type { User } from '@/composables/auth/types'

export const getUser = async (): Promise<User> => {
  try {
    return await getCurrentUserFromSession()
  } catch (error) {
    console.error('Error getting user:', error)
    return {
      isAuthenticated: false,
    }
  }
}

export const getAccessToken = async (forceRefresh = false): Promise<string | undefined> => {
  try {
    const session = await getAuthSession(forceRefresh)
    if (!session?.accessToken) {
      console.warn('Access token not available in session')
      return undefined
    }
    const accessToken = session.accessToken
    if (!accessToken || accessToken.trim() === '') {
      console.warn('Access token is empty')
      return undefined
    }

    return accessToken
  } catch (error) {
    console.error('Failed to get access token:', error)
    return undefined
  }
}

